export default (() => {
  const MINIMUM_BUFFER = 48;
  const MINIMUM_PARAGRAPH = 24;
  const ATTRIBUTE_SHORTEN_TO = 'data-shorten-text-to';
  const ATTRIBUTE_SHORTEN_BREAKPOINTS = 'data-shorten-text-exclude';
  const ATTRIBUTE_SHORTEN_BUTTON_TEXT = 'data-shorten-button-text';
  const ATTRIBUTE_SHORTEN_BUTTON_CLASS = 'data-shorten-button-class';
  const ATTRIBUTE_SHORTEN_CLOSE_ATTRIBUTE = 'data-shorten-text-clone';
  const breakpointsLookup = {
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 0
  };
  const getBreakpoint = () => {
    for (const breakpoint in breakpointsLookup) {
      if (window.innerWidth >= breakpointsLookup[breakpoint]) {
        return breakpoint;
      }
    }
    return false;
  };
  const nodes = document.querySelectorAll('[' + ATTRIBUTE_SHORTEN_TO + ']');
  for (const node of nodes) {
    let maximumShortLength = node.getAttribute(ATTRIBUTE_SHORTEN_TO);
    maximumShortLength = Number.parseInt(maximumShortLength);
    if (Number.isNaN(maximumShortLength)) {
      console.warn('Value for "' + ATTRIBUTE_SHORTEN_TO + '" attribute is not a number!');
      continue;
    }
    let allow = true;

    // Check if it should be excluded from the breakpoint.
    if (node.hasAttribute(ATTRIBUTE_SHORTEN_BREAKPOINTS)) {
      const excludeBreakpoints = node.getAttribute(ATTRIBUTE_SHORTEN_BREAKPOINTS).split(',').map(breakpoint => breakpoint.trim().toLowerCase());
      if (excludeBreakpoints.indexOf(getBreakpoint()) >= 0) {
        allow = false;
      }
    }

    // Skip if not allowed.
    if (!allow) {
      continue;
    }

    // Check if text extends max length.
    let bufferLength = maximumShortLength / 3;
    if (bufferLength < MINIMUM_BUFFER) {
      bufferLength = MINIMUM_BUFFER;
    }
    let minimumTotalLength = maximumShortLength + bufferLength;
    let textLength = node.textContent.replace(/\s/, ' ').length;
    if (textLength < minimumTotalLength) {
      continue;
    }

    // Check for additional customization attributes.
    let buttonText = 'Lees meer';
    if (node.hasAttribute(ATTRIBUTE_SHORTEN_BUTTON_TEXT)) {
      buttonText = node.getAttribute(ATTRIBUTE_SHORTEN_BUTTON_TEXT);
    }
    let buttonClass = 'btn btn-tertiary';
    if (node.hasAttribute(ATTRIBUTE_SHORTEN_BUTTON_CLASS)) {
      buttonClass = node.getAttribute(ATTRIBUTE_SHORTEN_BUTTON_CLASS);
    }

    // Copy element and hide original.
    const nodeClone = node.cloneNode(true);
    nodeClone.setAttribute(ATTRIBUTE_SHORTEN_CLOSE_ATTRIBUTE, true);
    node.parentNode.insertBefore(nodeClone, node);

    // Setup template for holding to actual content.
    const template = document.createElement('template');
    node.parentNode.insertBefore(template, node);
    template.append(node);

    // Shorten copy.
    let processedLength = 0;
    const processText = (node, isRoot = false) => {
      if (processedLength >= maximumShortLength) {
        if (isRoot) {
          node.textContent = '';
        } else {
          node.remove();
        }
        return false;
      }
      if (node.nodeType === 3) {
        let nodeText = node.textContent.replace(/\s/, ' ');
        let nodeLength = nodeText.length;
        // Calculate wether text exceeds it.
        if (processedLength + nodeLength >= maximumShortLength) {
          // Calculate the length the text has to be shorten to.
          let shortenLength = maximumShortLength - processedLength;
          if (shortenLength < MINIMUM_PARAGRAPH) {
            shortenLength = MINIMUM_PARAGRAPH;
          }
          // Check if string is longer than expected.
          if (shortenLength < nodeLength) {
            nodeText = nodeText.substring(0, shortenLength);

            // Trim to last index of whitespace.
            const lastWhitespace = nodeText.lastIndexOf(' ');
            if (lastWhitespace >= 0) {
              nodeText = nodeText.substring(0, lastWhitespace);
            }

            // Append ellipses.
            node.textContent = nodeText + '…';
          }
        }
        processedLength += nodeLength;
        return true;
      }
      let i = 0;
      for (; i < node.childNodes.length;) {
        const exists = processText(node.childNodes[i]);
        if (exists) {
          i++;
        }
      }
      return true;
    };
    processText(nodeClone, true);

    // Append button.
    const button = document.createElement('button');
    nodeClone.appendChild(button);
    button.textContent = buttonText;
    button.setAttribute('class', buttonClass);

    // Set height to new node for a single frame in order for an animation to be added.
    const updateHeight = () => {
      node.style.maxHeight = nodeClone.offsetHeight - button.offsetHeight + 'px';
    };
    requestAnimationFrame(updateHeight);
    window.addEventListener('resize', updateHeight);
    button.addEventListener('click', () => {
      // Clone template node into dom.
      nodeClone.parentNode.insertBefore(node, nodeClone);

      // Stop updating on window resize.
      window.removeEventListener('resize', updateHeight);

      // Remove clone and template node.
      nodeClone.remove();
      template.remove();
      requestAnimationFrame(() => {
        node.style.maxHeight = null;
        node.dispatchEvent(new CustomEvent('shorten-text-expanding', {
          bubbles: true,
          detail: {
            target: node
          }
        }));

        // Wait for animation to be done, then send the next event.
        node.addEventListener('animationcancel animationend transitioncancel transitionend', function () {
          node.dispatchEvent(new CustomEvent('shorten-text-expanded', {
            bubbles: true,
            detail: {
              target: node
            }
          }));
        });
      });
    });
  }
});